import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pricing-section',
  templateUrl: './pricing-section.component.html',
  styleUrls: ['./pricing-section.component.css']
})
export class PricingSectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
